import betslip from '@gin-betting/betslip';
import core from '@gin-betting/core';
import { Seq, Set } from 'immutable';
import { createSelector } from 'reselect';

import { usePureSelector } from 'hooks';

const {
    utils: { getIdsFromBetslipOddId, splitMarketPath },
} = core;
const {
    selectors: { selectBetslipOddIds },
} = betslip;

const selectGroupedMarketIdsByMatchId = createSelector(
    selectBetslipOddIds,
    betslipOddIds => {
        const groupedMarketIdsByMatchId = betslipOddIds
            .map(betslipOddId => getIdsFromBetslipOddId(betslipOddId).marketId)
            .toSet()
            .groupBy(marketId => splitMarketPath(marketId)?.matchId)
            .entrySeq() as Seq.Indexed<[string, Set<string>]>;

        return groupedMarketIdsByMatchId;
    }
);

interface Output {
    groupedMarketIdsByMatchId: Seq.Indexed<[string, Set<string>]>;
}

const useBetslipListSubscription = (): Output => {
    const groupedMarketIdsByMatchId = usePureSelector(s =>
        selectGroupedMarketIdsByMatchId(s)
    );

    return { groupedMarketIdsByMatchId };
};

export default useBetslipListSubscription;
